module.exports = __webpack_public_path__ + "static/img/vaimauga-demitric.42d3b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vaimauga-demitric.jpg
// module id = sJy6
// module chunks = 0